function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.56064 0H2.19717C0.985662 0 0 0.985662 0 2.19717V6.56064C0 7.77215 0.985662 8.75781 2.19717 8.75781H6.56064C7.77215 8.75781 8.75781 7.77215 8.75781 6.56064V2.19717C8.75781 0.985662 7.77215 0 6.56064 0ZM7.27344 6.56064C7.27344 6.95367 6.95367 7.27344 6.56064 7.27344H2.19717C1.80415 7.27344 1.48438 6.95367 1.48438 6.56064V2.19717C1.48438 1.80415 1.80415 1.48438 2.19717 1.48438H6.56064C6.95367 1.48438 7.27344 1.80415 7.27344 2.19717V6.56064Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.7734 0H12.4688C11.241 0 10.2422 0.998836 10.2422 2.22656V6.53125C10.2422 7.75898 11.241 8.75781 12.4688 8.75781H16.7734C18.0012 8.75781 19 7.75898 19 6.53125V2.22656C19 0.998836 18.0012 0 16.7734 0ZM17.5156 6.53125C17.5156 6.94049 17.1827 7.27344 16.7734 7.27344H12.4688C12.0595 7.27344 11.7266 6.94049 11.7266 6.53125V2.22656C11.7266 1.81732 12.0595 1.48438 12.4688 1.48438H16.7734C17.1827 1.48438 17.5156 1.81732 17.5156 2.22656V6.53125Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.56064 10.2422H2.19717C0.985662 10.2422 0 11.2278 0 12.4394V16.8028C0 18.0143 0.985662 19 2.19717 19H6.56064C7.77215 19 8.75781 18.0143 8.75781 16.8028V12.4394C8.75781 11.2278 7.77215 10.2422 6.56064 10.2422ZM7.27344 16.8028C7.27344 17.1959 6.95367 17.5156 6.56064 17.5156H2.19717C1.80415 17.5156 1.48438 17.1959 1.48438 16.8028V12.4394C1.48438 12.0463 1.80415 11.7266 2.19717 11.7266H6.56064C6.95367 11.7266 7.27344 12.0463 7.27344 12.4394V16.8028Z",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M16.7734 10.2422H12.4688C11.241 10.2422 10.2422 11.241 10.2422 12.4688V16.7734C10.2422 18.0012 11.241 19 12.4688 19H16.7734C18.0012 19 19 18.0012 19 16.7734V12.4688C19 11.241 18.0012 10.2422 16.7734 10.2422ZM17.5156 16.7734C17.5156 17.1827 17.1827 17.5156 16.7734 17.5156H12.4688C12.0595 17.5156 11.7266 17.1827 11.7266 16.7734V12.4688C11.7266 12.0595 12.0595 11.7266 12.4688 11.7266H16.7734C17.1827 11.7266 17.5156 12.0595 17.5156 12.4688V16.7734Z",
  fill: "currentColor"
});

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.ea8f07b4.svg";
export { ForwardRef as ReactComponent };